var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { FilterService } from "~/utils/filter.service";
var StrategyConfigService = /** @class */ (function () {
    function StrategyConfigService() {
    }
    /**
     * 获取支持的策略字段
     */
    StrategyConfigService.prototype.getStrategyFields = function () {
        return this.netService.send({
            server: dataimpService.strategyConfigController.getStrategyFields
        });
    };
    /**
     * 创建策略
     */
    StrategyConfigService.prototype.createStrategy = function (data) {
        return this.netService.send({
            server: dataimpService.strategyConfigController.createStrategy,
            data: data,
            loading: true
        });
    };
    /**
     * 修改策略
     */
    StrategyConfigService.prototype.updateStrategy = function (data) {
        return this.netService.send({
            server: dataimpService.strategyConfigController.updateStrategy,
            data: data,
            loading: true
        });
    };
    /**
     * 作废/终止
     * @param data
     */
    StrategyConfigService.prototype.updateStrategyStatus = function (data) {
        return this.netService.send({
            server: dataimpService.strategyConfigController.updateStrategyStatus,
            data: {
                id: data.id,
                strategyStatus: data.strategyStatus
            },
        });
    };
    /**
     * 分页查询策略
     */
    StrategyConfigService.prototype.queryStrategyConfigPage = function (data, page) {
        return this.netService.send({
            server: dataimpService.strategyConfigController.queryStrategyConfigPage,
            data: {
                name: data.name,
                strategyStatus: data.strategyStatus,
                executionFrequency: data.executionFrequency,
                latelyDatetimeMin: FilterService.dateRanageFormat(data.startDate).start,
                latelyDatetimeMax: FilterService.dateRanageFormat(data.startDate).end
            },
            page: page
        });
    };
    /**
     * 通过ID获取策略
     * @param data
     */
    StrategyConfigService.prototype.getOneById = function (id) {
        return this.netService.send({
            server: dataimpService.strategyConfigController.getOneById,
            data: {
                id: id
            }
        });
    };
    /**
     * 通过ID删除策略
     * @param data
     */
    StrategyConfigService.prototype.delete = function (id) {
        return this.netService.send({
            server: dataimpService.strategyConfigController.delete,
            data: {
                id: id
            }
        });
    };
    /**
     * 策略执行记录查看
     */
    StrategyConfigService.prototype.queryStrategyConfigDetailData = function (data, page) {
        return this.netService.send({
            server: dataimpService.strategyConfigController.queryStrategyConfigDetailData,
            data: {
                name: data.name,
                caseNumber: data.caseNumber,
                customerName: data.customerName,
                runningTimeMin: data.checkTime.length ? FilterService.dateTimeFormat(data.checkTime[0]) : '',
                runningTimeMax: data.checkTime.length ? FilterService.dateTimeFormat(data.checkTime[1]) : '',
                id: data.id
            },
            page: page
        });
    };
    /**
     * 获取支持的策略字段
     */
    StrategyConfigService.prototype.getLabelNameFields = function () {
        return this.netService.send({
            server: dataimpService.strategyConfigController.getLabelNameFields
        });
    };
    __decorate([
        Inject(NetService)
    ], StrategyConfigService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], StrategyConfigService.prototype, "createStrategy", null);
    __decorate([
        Debounce()
    ], StrategyConfigService.prototype, "updateStrategy", null);
    return StrategyConfigService;
}());
export { StrategyConfigService };
